import './_nav.js';


var fromTop = 200;

( function( $ ) {

   function scrolled () {
      if ( ( $(window).scrollTop() - $('body').offset().top ) > fromTop ) {
         $('body').addClass("scrolled");
      } else {
         $('body').removeClass("scrolled");
      }
   }


   $(window).on("resize scroll", function () {
      scrolled();
   });



} )( jQuery );

 
